import { isRunByJest } from '@pb/jest-helpers';
import { TEnvironment, TEnvironmentSettings } from './environment.types';

export function getCurrentEnvironment(
    runtimeSubstitutedEnvironment = '#{ENVIRONMENT}'
): TEnvironment {
    if (isRunByJest()) {
        return 'qa';
    }

    if (
        runtimeSubstitutedEnvironment === 'development' ||
        runtimeSubstitutedEnvironment === 'qa' ||
        runtimeSubstitutedEnvironment === 'production'
    ) {
        return runtimeSubstitutedEnvironment as TEnvironment;
    }

    return 'development';
}

export function getEnvironmentSettings(
    environment?: TEnvironment
): TEnvironmentSettings {
    environment = environment || getCurrentEnvironment();

    // TODO: This needs replacing with a call to the Azure App Configuration service.
    // @See https://dev.azure.com/purplebricks/FrontEnd/_git/fe-mono/pullrequest/47322 as a starting point for this work.
    switch (environment) {
        case 'development':
            return {
                isProduction: false,
                environment: 'development',
                baseUrl: 'http://localhost:4200',
                googleTagManagerApiKey: 'GTM-TFWHR6',
                googleTagManagerScriptUrl: '',
                cookiebotId: '0cd7538a-48dc-4bb8-8be3-23079c2a5c04',
                orderApiUrl: 'https://commerce-order.qa.pbr.so/api/v2',
                basketApiUrl: 'https://commerce-basket.qa.pbr.so/api/v1',
                paymentApiUrl: 'https://commerce-payments.qa.pbr.so/api/v1',
                realexBaseUrl: 'https://pay.sandbox.realexpayments.com',
                propositionApiUrl: 'https://seller-proposition-api.qa.pbr.so',
                instructUrl: 'https://qa.pbr.so/instruct?propertyId=',
                sanityProjectId: 'd1b7o4yc',
                sanityDataset: 'development',
                oldMessages: 'https://account.qa.pbr.so/messages',
                messages: 'https://qa.pbr.so/messages',
                facadeApi: 'https://api.qa.pbr.so/facade/v1',
                facadeApiBaseUrl: 'https://api.qa.pbr.so/facade',
                accountApiUrl: 'https://qa.pbr.so/account-api',
                complianceApi: 'https://api.qa.pbr.so/amlsellers-api/v1',
                outlookSyncApi:
                    'https://api.qa.pbr.so/outlook-api/v1/agent/outlook-sync',
                callCenterPhoneNumber: '0800 810 8008',
                baseApiUrl: 'https://qa.pbr.so/api',
                expertTeamApi:
                    'https://expertteam-webapi.qa.pbr.so/api/SalesExpertTeam',
                onlineAssestsUrl:
                    'https://pbonlineassets.blob.core.windows.net/web-images',
                propertyApi: 'https://api.qa.pbr.so/property-api/v1',
                reviewsApi: 'https://marketing-reviews.qa.pbr.so/api/v1',
                advertApi: 'https://pb-advert.qa.pbr.so/api/v1',
                propertyPortalApi: 'https://api.qa.pbr.so/property-portal-api',
                imgixAgentUrl:
                    'https://purplebricks-agents-qa.imgix.net/agentfiles',
                graphqlApi: 'https://qa.pbr.so/graphql',
                buyerAmlApi: 'https://api.qa.pbr.so/amlbuyers-api',
                imgixWebUrl: 'https://purplebricks-web.imgix.net',
                agentBookValApi: 'https://api.qa.pbr.so/agents-bookval/v1/',
                scheduling: 'https://qa.pbr.so/scheduling/v1',
                schedulingApi: 'https://api.qa.pbr.so/scheduling/v2',
                moneyBackGuaranteeApi: 'https://api.qa.pbr.so/payment-mbg/v1',
                offersUrl: 'https://api.qa.pbr.so/sales-offers-api/v1',
                apiBaseUrl: 'https://api.qa.pbr.so',
                bruce: true,
                valuationApi: 'https://api.qa.pbr.so/valuations-api',
                paypalClientId:
                    'AYZ-CtywznVYsF0GeUQsIIiYs6J61b7A0nK7ptfYanpNg2QUL08-1z4QUpsw5pQ9SGZGwfYFJKmr1tN8',
                paypalUrl: 'https://api.qa.pbr.so/commerce-api/v1/payment',
            };

        case 'qa':
            return {
                isProduction: false,
                environment: 'qa',
                baseUrl: 'https://qa.pbr.so',
                googleTagManagerApiKey: 'GTM-TFWHR6',
                googleTagManagerScriptUrl: 'https://qa.pbr.so/metrics/',
                cookiebotId: '0cd7538a-48dc-4bb8-8be3-23079c2a5c04',
                orderApiUrl: 'https://commerce-order.qa.pbr.so/api/v2',
                basketApiUrl: 'https://commerce-basket.qa.pbr.so/api/v1',
                paymentApiUrl: 'https://commerce-payments.qa.pbr.so/api/v1',
                realexBaseUrl: 'https://pay.sandbox.realexpayments.com',
                propositionApiUrl: 'https://seller-proposition-api.qa.pbr.so',
                instructUrl: 'https://qa.pbr.so/instruct?propertyId=',
                sanityProjectId: 'd1b7o4yc',
                sanityDataset: 'development',
                oldMessages: 'https://account.qa.pbr.so/messages',
                messages: 'https://qa.pbr.so/messages',
                facadeApi: 'https://api.qa.pbr.so/facade/v1',
                facadeApiBaseUrl: 'https://api.qa.pbr.so/facade',
                accountApiUrl: 'https://qa.pbr.so/account-api',
                complianceApi: 'https://api.qa.pbr.so/amlsellers-api/v1',
                propertyApi: 'https://api.qa.pbr.so/property-api/v1',
                outlookSyncApi:
                    'https://qa.pbr.so/outlook-api/v1/agent/outlook-sync',
                callCenterPhoneNumber: '0800 810 8008',
                baseApiUrl: 'https://qa.pbr.so/api',
                expertTeamApi:
                    'https://expertteam-webapi.qa.pbr.so/api/SalesExpertTeam',
                onlineAssestsUrl:
                    'https://pbonlineassets.blob.core.windows.net/web-images',
                reviewsApi: 'https://marketing-reviews.qa.pbr.so/api/v1',
                advertApi: 'https://pb-advert.qa.pbr.so/api/v1',
                propertyPortalApi: 'https://api.qa.pbr.so/property-portal-api',
                imgixAgentUrl:
                    'https://purplebricks-agents-qa.imgix.net/agentfiles',
                graphqlApi: 'https://qa.pbr.so/graphql',
                buyerAmlApi: 'https://api.qa.pbr.so/amlbuyers-api',
                imgixWebUrl: 'https://purplebricks-web.imgix.net',
                agentBookValApi: 'https://api.qa.pbr.so/agents-bookval/v1/',
                scheduling: 'https://qa.pbr.so/scheduling/v1',
                schedulingApi: 'https://api.qa.pbr.so/scheduling/v2',
                moneyBackGuaranteeApi: 'https://api.qa.pbr.so/payment-mbg/v1',
                offersUrl: 'https://api.qa.pbr.so/sales-offers-api/v1',
                apiBaseUrl: 'https://api.qa.pbr.so',
                bruce: true,
                valuationApi: 'https://api.qa.pbr.so/valuations-api',
                paypalClientId:
                    'AYZ-CtywznVYsF0GeUQsIIiYs6J61b7A0nK7ptfYanpNg2QUL08-1z4QUpsw5pQ9SGZGwfYFJKmr1tN8',
                paypalUrl: 'https://api.qa.pbr.so/commerce-api/v1/payment',
            };

        case 'production':
            return {
                isProduction: true,
                environment: 'production',
                baseUrl: 'https://www.purplebricks.co.uk',
                googleTagManagerApiKey: 'GTM-KXGNTB',
                googleTagManagerScriptUrl:
                    'https://www.purplebricks.co.uk/metrics/',
                cookiebotId: '0cd7538a-48dc-4bb8-8be3-23079c2a5c04',
                orderApiUrl: 'https://commerce-order.purplebricks.co.uk/api/v2',
                basketApiUrl:
                    'https://commerce-basket.purplebricks.co.uk/api/v1',
                paymentApiUrl:
                    'https://commerce-payments.purplebricks.co.uk/api/v1',
                realexBaseUrl: 'https://pay.realexpayments.com',
                propositionApiUrl:
                    'https://seller-proposition-api.purplebricks.co.uk',
                instructUrl:
                    'https://www.purplebricks.co.uk/instruct?propertyId=',
                sanityProjectId: 'd1b7o4yc',
                sanityDataset: 'production',
                oldMessages: 'https://account.purplebricks.co.uk/messages',
                messages: 'https://purplebricks.co.uk/messages',
                facadeApi: 'https://api.purplebricks.co.uk/facade/v1',

                propertyApi: 'https://api.purplebricks.co.uk/property-api/v1',
                facadeApiBaseUrl: 'https://api.purplebricks.co.uk/facade',
                accountApiUrl: 'https://api.purplebricks.co.uk/account-api',
                complianceApi:
                    'https://api.purplebricks.co.uk/amlsellers-api/v1',
                outlookSyncApi:
                    'https://www.purplebricks.co.uk/outlook-api/v1/agent/outlook-sync',
                callCenterPhoneNumber: '0800 810 8008',
                baseApiUrl: 'https://www.purplebricks.co.uk/api',
                expertTeamApi:
                    'https://expertteam-webapi.purplebricks.co.uk/api/SalesExpertTeam',
                onlineAssestsUrl:
                    'https://pbonlineassets.blob.core.windows.net/web-images',
                reviewsApi:
                    'https://marketing-reviews.purplebricks.co.uk/api/v1',
                advertApi: 'https://pb-advert.purplebricks.co.uk/api/v1',
                propertyPortalApi:
                    'https://api.purplebricks.co.uk/property-portal-api',
                imgixAgentUrl:
                    'https://purplebricks-agents.imgix.net/agentfiles',
                graphqlApi: 'https://www.purplebricks.co.uk/graphql',
                buyerAmlApi: 'https://api.purplebricks.co.uk/amlbuyers-api',
                imgixWebUrl: 'https://purplebricks-web.imgix.net',
                agentBookValApi:
                    'https://www.purplebricks.co.uk/agents-bookval/v1/',
                scheduling: 'https://api.purplebricks.co.uk/scheduling/v1',
                schedulingApi: 'https://api.purplebricks.co.uk/scheduling/v2',
                moneyBackGuaranteeApi:
                    'https://api.purplebricks.co.uk/payment-mbg/v1',
                offersUrl: 'https://api.purplebricks.co.uk/sales-offers-api/v1',
                apiBaseUrl: 'https://api.purplebricks.co.uk',
                bruce: true,
                valuationApi: 'https://api.purplebricks.co.uk/valuations-api',
                paypalClientId:
                    'AYZ-CtywznVYsF0GeUQsIIiYs6J61b7A0nK7ptfYanpNg2QUL08-1z4QUpsw5pQ9SGZGwfYFJKmr1tN8',
                paypalUrl:
                    'https://api.purplebricks.co.uk/commerce-api/v1/payment',
            };
    }
}

export function getCombinedAppAndDefaultEnvironmentSettings<
    T extends Record<string, unknown>
>(
    appEnvironmentSettings: Record<TEnvironment, T>,
    environment?: TEnvironment
): TEnvironmentSettings & T {
    environment = environment || getCurrentEnvironment();

    const defaultEnvironmentSettings = getEnvironmentSettings(environment);

    return {
        ...defaultEnvironmentSettings,
        ...appEnvironmentSettings[environment],
    };
}
